var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28757 10.8989C2.59902 8.23022 3.05409 6.22919 3.47612 4.80756C3.82217 3.64188 3.99519 3.05903 4.70474 2.52951C5.41429 2 6.13953 2 7.59001 2H12.41C13.8605 2 14.5857 2 15.2953 2.52951C16.0048 3.05903 16.1779 3.64188 16.5239 4.80756C16.946 6.22919 17.401 8.23022 17.7125 10.8989C18.0795 14.0442 18.2631 15.6168 17.2024 16.8084C16.1418 18 14.423 18 10.9853 18H9.01478C5.57709 18 3.85824 18 2.79761 16.8084C1.73699 15.6168 1.92052 14.0442 2.28757 10.8989Z",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 5.55542C7.33325 7.02818 8.52714 8.22209 9.99994 8.22209C11.4727 8.22209 12.6666 7.02818 12.6666 5.55542",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 5.55542C7.33325 7.02818 8.52714 8.22209 9.99994 8.22209C11.4727 8.22209 12.6666 7.02818 12.6666 5.55542",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStops);
export default __webpack_public_path__ + "static/media/stops.9b1a9d2c450e756e2b3aa837d57f1d42.svg";
export { ForwardRef as ReactComponent };